var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPauseAudioIcon = function SvgPauseAudioIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 13c-.736 0-1.334.597-1.334 1.333v21.334c0 .736.598 1.333 1.334 1.333h5.333c.737 0 1.334-.597 1.334-1.333V14.333c0-.736-.597-1.333-1.334-1.333zM27.667 13c-.737 0-1.334.597-1.334 1.333v21.334c0 .736.597 1.333 1.334 1.333H33c.736 0 1.333-.597 1.333-1.333V14.333c0-.736-.597-1.333-1.333-1.333z"
  })));
};
export default SvgPauseAudioIcon;